import { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { useAuth } from '../context/AuthContext';

/**
 * A component that updates Datadog RUM with the current user information
 * whenever the user's authentication state changes.
 * This ensures user ID is set globally for all Datadog events and session replays.
 */
export const DatadogUserTracker: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      // Set user information globally in Datadog RUM
      datadogRum.setUser({
        id: user.userId,
        email: user.email
      });
    } else {
      // Clear user information when not logged in
      datadogRum.clearUser();
    }
  }, [user]);

  // This component doesn't render anything itself, just forwards children
  return <>{children}</>;
};
